import r2wc from '@r2wc/react-to-web-component';
import { useState } from 'react';

import { windowIsDefined } from '@klv/shared/utils/functions';
import { Tooltip, TooltipTrigger, TooltipContent } from '@klv/atoms/tooltip';
import Icon from '@klv/atoms/icon';


import * as styles from './styles/klv-tooltip.module.scss';

import type { IKlvTooltipProps } from './types';

// 1. Create a wrapper component that renders our Tooltip with the desired props.
export const KlvTooltipWrapper = ({ title, body }: IKlvTooltipProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip open={open}>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={styles.triggerSpan}
        >
          <Icon iconName="InformationOutline" fill="currentColor" />
        </button>
      </TooltipTrigger>
      <TooltipContent className={styles.tooltipContent}>
        <strong>{title}</strong>
        <br />
        <p>{body}</p>
      </TooltipContent>
    </Tooltip>
  );
};

// 2. Convert the React component to a web component, mapping attributes to props.
const KlvTooltip = r2wc(KlvTooltipWrapper, {
  props: {
    title: 'string',
    body: 'string',
  } as Record<keyof IKlvTooltipProps, 'string'>,
});

// 3. Export a function to register the custom element.
export const registerKlvTooltip = () => {
  if (windowIsDefined() && !customElements.get('klv-tooltip')) {
    customElements.define('klv-tooltip', KlvTooltip);
  }
};
